// extracted by mini-css-extract-plugin
export var arrow = "_lx-1";
export var content = "_lx-0";
export var highlighted = "_lx-2";